export default [
  {
    path: '',
    name: 'login banner list',
    component: () => import('@/views/app/login-banner/list/page-list.vue'),
    meta: { title: 'Daftar Banner Login' },
  },
  {
    path: 'tambah',
    name: 'login banner create',
    component: () => import('@/views/app/login-banner/create/page-create.vue'),
    meta: { title: 'Tambah Banner Login' },
  },
  {
    path: ':id',
    name: 'login banner edit',
    component: () => import('@/views/app/login-banner/edit/page-edit.vue'),
    props: true,
    meta: { title: 'Edit Banner Login' },
  },
]
